import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import {
  MissionLifecycleFragmentFragment,
  RequestMissionProposalApproval,
  RequestMissionProposalApprovalMutation,
  RequestMissionProposalApprovalMutationVariables,
} from "@/gql"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import CalloutCard from "@/modules/Missions/components/CalloutCard/CalloutCard.vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmitMissionProposal',
  props: {
    mission: null,
    refetchQueries: null
  },
  setup(__props: any) {

const props = __props as {
  mission: MissionLifecycleFragmentFragment
  refetchQueries: RefetchQueryDescription
}



const isSubmitting = ref(false)
const showDialog = ref(false)

const { mutate } = useMutation()
const { addSuccess } = useNotification()

const submitTeam = () => {
  showDialog.value = true
}

const submitProposal = async () => {
  isSubmitting.value = true
  const result = await mutate<
    RequestMissionProposalApprovalMutation,
    RequestMissionProposalApprovalMutationVariables
  >({
    mutation: RequestMissionProposalApproval,
    variables: {
      missionLifecycleId: props.mission.prn,
    },
    refetchQueries: props.refetchQueries,
    done: () => {
      showDialog.value = false
      isSubmitting.value = false
    },
  })

  if (result && !result?.data?.requestMissionProposalApproval?.error) {
    addSuccess("Mission proposal submitted successfully")
  }
}

return { __sfc: true,props, isSubmitting, showDialog, mutate, addSuccess, submitTeam, submitProposal, CalloutCard }
}

})